export const BOOTCAMP_PAGE_POSTHOG_VARIANTS = ['control', 'test'] as const;

export const BOOTCAMP_PAGE_EXPERIMENT = {
  name: 'ai_trading_bootcamp_control_vs_clarity_2026_08_31',
  featureFlag: 'ai-trading-bootcamp-control-vs-clarity-2026-08-31',
  posthogExperimentId: 459167,
  predecessorPosthogExperimentId: 445277,
  status: 'active',
  posthogVariants: BOOTCAMP_PAGE_POSTHOG_VARIANTS,
  variants: {
    control: 'Current bootcamp page',
    test: 'Clarity bootcamp page',
  },
  primaryMetric: 'Live Bootcamp checkout conversion',
  secondaryMetrics: ['Live Bootcamp payment conversion', 'Live Bootcamp revenue per exposed user'],
} as const;
